import { axiosCore } from './http-core-service';
import { ContractDto } from './dtos/contract.dto';
import { ContractUpdateDto } from './dtos/contract-update.dto';
import { ContractFormInfosDto } from './dtos/form/contract-form-infos.dto';
import { MeterReadingDto } from './dtos/meter-reading.dto';
import { AddressContractDto } from './dtos/address-contract.dto';
import { MoveHouseDto } from './dtos/move-house.dto';

const urlContrat = '/rattachement_contrats/';

/**
 * Appel API pour le rattachement d'un contrat à un Compte Abonné
 * @param data Informations du contrat à rattacher
 */
export const attachContract = async (data: ContractFormInfosDto): Promise<any> => {
    const response = await axiosCore.post('/rattachement_contrats', data);
    return response.data;
};

/**
 * Appel API pour la récupération des informations d'un contrat
 * @param id Identifiant du contrat à récupérer
 */
export const getContract = async (id: string | undefined) => {
    const response = await axiosCore.get(urlContrat + id);
    return response.data;
};

/**
 * Appel API pour déttacher un contrat à un Compte Abonné
 * @param id du contrat
 */
export const detachedContract = async (id: string): Promise<string> => {
    const response = await axiosCore.delete(urlContrat + id);
    return response.data?.message;
};

/**
 * Méthode permet de définir si un compte possède des contrats
 */
export const hasContract = async (): Promise<boolean> => {
    const response = await axiosCore.get('/rattachement_contrats?page=1&itemsPerPage=0');
    return response.data['hydra:totalItems'] !== undefined && response.data['hydra:totalItems'] > 0;
};

/**
 * Méthode permet de récupérer tous les contrats du client avec leurs données
 */
export const getContracts = async (): Promise<Array<ContractDto>> => {
    const response = await axiosCore.get('/rattachement_contrats?pagination=false');
    return response.data;
};

/**
 * Méthode qui permet de mettre à jour le choix de la facture électronique
 */
export const updateContract = async (contractId: string, data: ContractUpdateDto): Promise<any> => {
    const response = await axiosCore.patch(urlContrat + contractId, data);
    return response.data;
};

/**
 * Appel API qui permet de créer un relevè sur un rattachement de contrat.
 * @param data données du relevè
 * @param idContract identifiant du contrat
 */
export const createMeterReading = async (data: MeterReadingDto, idContract: string | undefined): Promise<any> => {
    const response = await axiosCore.post('/rattachement_contrats/' + idContract + '/releves', data);
    return response.data;
};

/**
 * Appel API qui permet de changer l'adresse sur un rattachement de contrat.
 * @param data données du relevè
 * @param idContract identifiant du contrat
 */
export const changeAddressContract = async (data: AddressContractDto, idContract: string | undefined): Promise<any> => {
    const response = await axiosCore.post('/demandes/' + idContract + '/adresse_correspondance', data);
    return response.data;
};

/**
 * Appel API qui permet de signaler un déménagement.
 * @param data données pour le déménagement
 * @param idContract identifiant du contrat
 */
export const moveHouse = async (data: MoveHouseDto, idContract?: string): Promise<any> =>
    await axiosCore.post('/demandes/' + idContract + '/demenagement', data);
